import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const URL_PORTARIA = `${modulo.ARRECADACAO}/portaria`

const actions = {
  getPDFConfirmarDadosMinuta ({ commit }, id) {
    return axios({
      method: 'get',
      responseType: 'arraybuffer',
      url: `${URL_PORTARIA}/pdf?id=${id}`
    })
  },

  getPDFPortariaAssinado ({ commit }, id) {
    return axios({
      method: 'get',
      responseType: 'arraybuffer',
      url: `${URL_PORTARIA}/download?id=${id}`
    })
  },

  async savePortaria ({ commit }, { dados, id }) {
    const response = await axios({
      method: 'post',
      url: `${URL_PORTARIA}?idProcesso=${id}`,
      data: dados,
      error: true
    })
    return response
  },

  async savePortariaDiarioOficial ({ commit }, { dados, id }) {
    const response = await axios({
      method: 'post',
      url: `${URL_PORTARIA}/salvar/diarioOficial?id=${id}`,
      data: dados,
      error: true
    })
    return response
  },

  async finalizarPortaria ({ commit }, id) {
    const response = await axios({
      method: 'post',
      url: `${URL_PORTARIA}/finalizar`,
      data: {
        id
      },
      error: true
    })
    return response
  },

  async assinarPortaria ({ commit }, dadosAssinatura) {
    const response = await axios({
      method: 'post',
      url: `${URL_PORTARIA}/assinar`,
      data: dadosAssinatura,
      error: true,
      loader: false
    })
    return response
  },

  emitirPortaria ({ commit }, id) {
    return axios({
      method: 'get',
      responseType: 'arraybuffer',
      url: `${URL_PORTARIA}/pdf?id=${id}`
    })
  },

  atualizarDiarioOficial ({ commit }, dados) {
    return axios({
      method: 'post',
      url: `${URL_PORTARIA}/atualizaDadosDiario`,
      data: dados,
      error: true,
      loader: false
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/arrecadacao/portariaArrecadacao.js